module.exports = __webpack_public_path__ + "static/img/works-06.b4e4fd0a.png";